"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _ActionTypes = require("./actionTypes");
function default_1(namespace) {
    const ActionTypes = _ActionTypes.default(namespace);
    const initialState = {
        status: 'STANDBY'
    };
    const methods = {};
    methods[ActionTypes.GENERATE_PREVIEW_REQUEST] = (state, action) => {
        if (state.status === 'FETCHED' &&
            state.revision &&
            action.payload === state.revision.uuid) {
            return Object.assign(Object.assign({}, state), { convertStatus: 'CONVERTING', revision: Object.assign(Object.assign({}, state.revision), { preview: { uuid: '', status: 'PROCESSING' } }) });
        }
        return state;
    };
    methods[ActionTypes.GENERATE_PREVIEW_FAILURE] = (state, action) => {
        if (state.status === 'FETCHED' &&
            state.revision &&
            action.revisionUuid === state.revision.uuid) {
            return Object.assign(Object.assign({}, state), { convertStatus: 'FAILED', revision: Object.assign(Object.assign({}, state.revision), { preview: { uuid: '', status: 'FAILED' } }) });
        }
        return state;
    };
    methods[ActionTypes.GENERATE_PREVIEW_SUCCESS] = (state, action) => {
        if (state.status === 'FETCHED' &&
            state.revision &&
            action.data.revisionUuid === state.revision.uuid) {
            return Object.assign(Object.assign({}, state), { convertStatus: 'CONVERTED', revision: Object.assign(Object.assign({}, state.revision), { preview: { uuid: action.data.uuid, status: action.data.status } }) });
        }
        return state;
    };
    const reducer = (state = initialState, action) => {
        if (methods[action.type]) {
            return methods[action.type](state, action);
        }
        return state;
    };
    return { reducer, initialState, methods, ActionTypes };
}
exports.default = default_1;
//# sourceMappingURL=reducers.js.map